// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PFileProtectOutlinedSvg from "@fishx/icons-svg/es/asn/PFileProtectOutlined";
import FishxIcon from '../components/FishxIcon';

var PFileProtectOutlined = function PFileProtectOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PFileProtectOutlinedSvg
  }));
};

PFileProtectOutlined.displayName = 'PFileProtectOutlined';
export default React.forwardRef(PFileProtectOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PFileProtectOutlined.js
// module id = 3402
// module chunks = 0